var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLightMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24515_96129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25C9.625 11.25 10.1562 11.0312 10.5938 10.5938C11.0312 10.1562 11.25 9.625 11.25 9C11.25 8.375 11.0312 7.84375 10.5938 7.40625C10.1562 6.96875 9.625 6.75 9 6.75C8.375 6.75 7.84375 6.96875 7.40625 7.40625C6.96875 7.84375 6.75 8.375 6.75 9C6.75 9.625 6.96875 10.1562 7.40625 10.5938C7.84375 11.0312 8.375 11.25 9 11.25ZM9 12.75C7.9625 12.75 7.07813 12.3844 6.34688 11.6531C5.61563 10.9219 5.25 10.0375 5.25 9C5.25 7.9625 5.61563 7.07813 6.34688 6.34688C7.07813 5.61563 7.9625 5.25 9 5.25C10.0375 5.25 10.9219 5.61563 11.6531 6.34688C12.3844 7.07813 12.75 7.9625 12.75 9C12.75 10.0375 12.3844 10.9219 11.6531 11.6531C10.9219 12.3844 10.0375 12.75 9 12.75ZM3.75 9.75H0.75V8.25H3.75V9.75ZM17.25 9.75H14.25V8.25H17.25V9.75ZM8.25 3.75V0.75H9.75V3.75H8.25ZM8.25 17.25V14.25H9.75V17.25H8.25ZM4.8 5.8125L2.90625 3.99375L3.975 2.8875L5.775 4.7625L4.8 5.8125ZM14.025 15.1125L12.2063 13.2188L13.2 12.1875L15.0938 14.0063L14.025 15.1125ZM12.1875 4.8L14.0063 2.90625L15.1125 3.975L13.2375 5.775L12.1875 4.8ZM2.8875 14.025L4.78125 12.2063L5.8125 13.2L3.99375 15.0938L2.8875 14.025Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24515_96129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightMode);
export default __webpack_public_path__ + "static/media/icon-light-mode.07b24b9f8c14308611597775112919c3.svg";
export { ForwardRef as ReactComponent };